export default "__VITE_ASSET__Bdwlo8Pg__"